import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { TextBold } from '@components/typography';
import { QuestionBlueIcon } from '@assets/icons/index';
import { Section } from '../section';
import FilePreview from '@components/filePreview';
import React from 'react';

export default function HeaderSection({ isLoading, handleClose, selectedFile, handleChangeFile, link }) {
    return (
        <>
            <Flex className="section-header">
                <Flex alignItems="center">
                    <Text className="title">Upload Sellout</Text>
                </Flex>
                <Flex alignItems="center">
                    <Box opacity={isLoading ? 0.6 : 1} pointerEvents={isLoading ? 'none' : 'auto'}>
                        <a target="_blank" rel="noreferrer" href={link}>
                            <QuestionBlueIcon />
                            <TextBold className="guidline-text">Temukan Panduan Upload Disini!</TextBold>
                        </a>
                    </Box>

                    <Button disabled={isLoading} variant="unstyled" onClick={handleClose}>
                        <CloseIcon color="semantic.900" />
                    </Button>
                </Flex>
            </Flex>

            <Section title="File di Upload">
                <FilePreview accessFile={selectedFile} isLoading={isLoading} onClick={handleChangeFile} />
            </Section>
        </>
    );
}
